import React, { Fragment } from 'react';
import { Segment, Placeholder } from 'semantic-ui-react';
const BulletinTableItemPlaceHolder = () => {
    return (
        <Fragment>
            <Placeholder fluid style={{ marginTop: 10 }}>
                <Segment.Group>
                    <Segment style={{ minHeight: 15 }}>
                        <Placeholder>
                            <Placeholder.Header>
                                <Placeholder.Line />
                            </Placeholder.Header>
                            <Placeholder.Paragraph>
                                <Placeholder.Line />
                            </Placeholder.Paragraph>
                            <Placeholder.Paragraph>
                                <Placeholder.Line />
                            </Placeholder.Paragraph>
                            <Placeholder.Paragraph>
                                <Placeholder.Line />
                            </Placeholder.Paragraph>
                        </Placeholder>
                    </Segment>
                </Segment.Group>
            </Placeholder>
        </Fragment>
    );
};

export default BulletinTableItemPlaceHolder;
